import DashboardGridBase from "./shared/dashboard_grid_base"

// Tenant dashboard grid: shares the edit-mode engine with the group grid (see
// shared/dashboard_grid_base) and opens the shared widget config dialog. Uses container-query
// breakpoints and persists resizes through a single endpoint (resizeUrlValue).
export default class extends DashboardGridBase {
  static targets = ["configPlaceholder"]
  static values = { url: String, resizeUrl: String, heightUrl: String, errorMessage: String }

  get colSpanClasses() {
    return {
      1: ["col-span-4", "@xl:col-span-2", "@5xl:col-span-1"],
      2: ["col-span-4", "@2xl:col-span-2"],
      3: ["col-span-4", "@4xl:col-span-3"],
      4: ["col-span-4"],
    }
  }

  get colSpanRemovalList() {
    return ["col-span-4", "@xl:col-span-2", "@2xl:col-span-2", "@5xl:col-span-1", "@4xl:col-span-3"]
  }

  // Literal class names, never built — Tailwind v4 cannot see an interpolated one.
  get rowSpanClasses() {
    return { 1: "row-span-1", 2: "row-span-2", 3: "row-span-3" }
  }

  // Without a chosen height the row count follows width (WidgetDefinition#rows_for), so a
  // resize swaps the row span too — otherwise the cell keeps its old height until the server
  // re-renders it. A chosen height wins over the width (DashboardConfiguration.rows_for).
  updateWidgetWidth(container, newWidth) {
    super.updateWidgetWidth(container, newWidth)
    if (this.storedHeightOf(container) !== null) return

    const rows = JSON.parse(container.dataset.widgetRows || "{}")[newWidth]
    if (!rows) return

    container.classList.remove(...Object.values(this.rowSpanClasses))
    container.classList.add(this.rowSpanClasses[rows] || this.rowSpanClasses[2])
  }

  // Null while the widget follows its width: undoing a first height change clears it again
  // instead of pinning the rows the width happened to give it.
  storedHeightOf(cell) {
    const stored = cell.dataset.widgetStoredHeight
    return stored ? parseInt(stored, 10) : null
  }

  resizeRequest(_container, widgetId, newWidth) {
    return { url: this.resizeUrlValue, body: { widget_id: widgetId, width: newWidth } }
  }

  heightRequest(_container, widgetId, height) {
    return { url: this.heightUrlValue, body: { widget_id: widgetId, height } }
  }

  // The menu link loads the widget's form into the shared dialog's frame (Turbo follows
  // the link itself); until it arrives the dialog shows a placeholder, never the form of
  // the widget configured before.
  openWidgetConfig() {
    const dialog = document.getElementById("widget-config-dialog")
    if (!dialog) return

    const frame = dialog.querySelector("turbo-frame#widget-config")
    if (frame && this.hasConfigPlaceholderTarget) {
      frame.replaceChildren(this.configPlaceholderTarget.content.cloneNode(true))
      // Runs before Turbo handles the click: without the old src, reopening the same
      // widget is a src change too and reloads the form over the placeholder.
      frame.removeAttribute("src")
      frame.removeAttribute("complete")
    }
    dialog.showModal()
  }

  closeWidgetConfig(event) {
    event.currentTarget.closest("dialog")?.close()
  }

  widgetConfigSaved(event) {
    if (event.detail.success) event.target.closest("dialog")?.close()
  }
}
